import { RestaurantOpening } from "./RestaurantOpening";

export default RestaurantOpening;
